import { ProjectStatus } from '../enums/project-status.enum';
import { WorkflowDataTableValue } from './workflow-data-table-value.interface';

/** REV-22155 — one row of the person projects table. */
export interface PersonProjectTableValue {
    projectId: string;
    personId: string;
    /** "Nachname Vorname". */
    personName: string;
    /** Year of `periodEnd` ("Steuerperiode 2025"). */
    taxYear: number;
    projectStatus: ProjectStatus;
    /** Tag names of the person, ready to show (the page resolves them via `personId`). */
    tags?: string[];
    assignee?: string | null;
    assigneeDeleted?: boolean;
    clerk?: string | null;
    clerkDeleted?: boolean;
    workflowData: WorkflowDataTableValue[] | null;
}
